module.exports = DEF.TG.Details.extend({
	template: require('./details.html'),
})
